import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Update these imports to use the new store structure
import { StoreProvider, RootStore } from './stores'; // Import from the index file

// Create the root store instance using the new RootStore class
const rootStore = new RootStore();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StoreProvider store={rootStore}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();